<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import Button from "../Button.svelte";
  import { hasNextPage } from "../../lib/stores/session";
  import { getCopy } from "../../lib/stores/copy";
  import { settingsStore } from "../../lib/stores/settings";
  import SharedHeading from "../SharedHeading.svelte";
  import { onMount } from "svelte";
  import { start } from "../../lib/helpers/steps/landing";
  import CustomHtml from "../CustomHTML.svelte";
  import Youtube from "../Youtube.svelte";
  import { checkLandingSession } from "../../lib/helpers/landing";
  import GiftPreview from "../GiftPreview.svelte";
  export let currentRoute;

  onMount(() => {
    try {
      checkLandingSession();
    } catch (error) {
      console.error(error);
    }
  });

  $: copyKey = $settingsStore?.isSocialGifting ? "socialGiftingLanding" : "landing";

  $: copy = $getCopy(copyKey) as Record<string, string>;
  $: isShowGiftPreview = $settingsStore?.isSocialGifting && $settingsStore?.isGiftLandingPreviewEnabled;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <div class="w-full">
      <div class="flex flex-col w-full mx-auto text-center lg:text-left lg:max-w-[29rem] lg:ml-[0]" class:items-center={isShowGiftPreview}>
        <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} isShowGiftPreview={!!isShowGiftPreview} />
        {#if isShowGiftPreview}
          <GiftPreview />
        {:else}
          <CustomHtml customHtml={copy.customHtml} />
        {/if}
        <Youtube videoId={copy.videoId} />
        <Button class="w-full lg:w-fit lg:min-w-[8.375rem] mt-[3rem]" primary disabled={!$hasNextPage} on:click={start}>
          {copy.startButtonCopy}
        </Button>
      </div>
    </div>
  </svelte:fragment>
</BaseStep>

<style>
</style>
